export default {
  download: 'Télécharger',
}